module.exports = __webpack_public_path__ + "static/media/logo_idovinabank.2519e752.svg";